import { SelectOption } from '~globals/types/commons';
import { ScheduleRouteRepetitionType } from '~globals/types/enums';

export const SCHEDULE_ROUTE_REPETION_TYPE_OPTIONS: SelectOption[] = [
  { label: 'Diariamente', value: ScheduleRouteRepetitionType.Daily },
  { label: 'Semanalmente', value: ScheduleRouteRepetitionType.Weekly },
  { label: 'Mensualmente', value: ScheduleRouteRepetitionType.Monthly },
];

export const SCHEDULE_ROUTE_WEEKLY_DAYS_OPTIONS: SelectOption[] = [
  { label: 'DO', value: 0 },
  { label: 'LU', value: 1 },
  { label: 'MA', value: 2 },
  { label: 'MI', value: 3 },
  { label: 'JU', value: 4 },
  { label: 'VI', value: 5 },
  { label: 'SA', value: 6 },
];
